import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Visible, 3:1-contrast keyboard focus styles for interactive elements.
 * Mirrors storyblocks-shell's design-system getAccessibleFocusStyles();
 * ring-opacity-100 also overrides translucent rings such as storywind Button's ring-opacity-20.
 *
 * @returns Tailwind classes for accessible focus styles
 */
export function getAccessibleFocusStyles(): string {
  return 'focus-visible:outline-accessible focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-opacity-100';
}
